import { API_ADMIN, ErroRespostaHttp } from '../../../shared/api/http';

export interface ArquivoDoRelatorio {
    nome: string;
    conteudo: Blob;
}

export function nomeDoArquivo(disposicao: string | null, turmaId: string): string {
    const codificado = disposicao?.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)?.[1];
    if (codificado) {
        try {
            return decodeURIComponent(codificado.trim());
        } catch {
        }
    }
    const simples = disposicao?.match(/filename\s*=\s*"?([^";]+)"?/i)?.[1];
    return simples?.trim() || `fiat-arcade_relatorio_${turmaId}.xlsx`;
}

export async function exportarRelatorio(turmaId: string): Promise<ArquivoDoRelatorio> {
    let resposta: Response;
    try {
        resposta = await fetch(`${API_ADMIN}/api/v1/relatorios/exportar?${new URLSearchParams({ turma_id: turmaId })}`, {
            credentials: 'include',
            headers: { Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
        });
    } catch {
        throw new Error('Falha de rede');
    }
    if (!resposta.ok) {
        let corpo: Record<string, unknown> | null = null;
        try {
            corpo = (await resposta.json()) as Record<string, unknown>;
        } catch {
            corpo = null;
        }
        throw new ErroRespostaHttp(resposta.status, resposta.headers.get('Retry-After'), corpo);
    }
    return {
        nome: nomeDoArquivo(resposta.headers.get('Content-Disposition'), turmaId),
        conteudo: await resposta.blob(),
    };
}

export function salvarArquivo({ nome, conteudo }: ArquivoDoRelatorio): void {
    const url = URL.createObjectURL(conteudo);
    const link = document.createElement('a');
    link.href = url;
    link.download = nome;
    link.rel = 'noopener';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
    
    window.setTimeout(() => URL.revokeObjectURL(url), 0);
}
